@if ({ value: value$ | async }; as asyncResult) {
  <div class="filter__block filter__block_content-type">
    @for (option of options | keyvalue: null; track option.key) {
      <span
        class="filter__value"
        (click)="onToggle(option.key)"
        [class.selected]="
          asyncResult.value!.includes(asContentTypeFilterValues(option.key))
        "
      >
        <div class="content-type">
          {{ option.value }}
        </div>
      </span>
    }
  </div>
}
